export const InfoIcon = ({ activeColor }: { activeColor: string }) => {
  const fillColor = activeColor === "#0f1560" ? "#EA580C" : "#0F1560";
  
  return(
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="9.75" stroke="#0F1560" strokeWidth="2" />
      <path
        d="M12 10V16"
        stroke="#0F1560"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <circle cx="12" cy="7" r="1.2" fill={fillColor} />
    </svg>
  );
};